<template>
    <div>
        <div
            v-show="value"
            ref="main"
            class="picker-panel"
            :class="customClass"
        >
            <transition name="fade">
                <div
                    class="mask"
                    ref="mask"
                    v-show="value"
                    @click="onCloseClick"
                    @touchmove.prevent="() => {}"
                ></div>
            </transition>
            <transition name="slide">
                <div
                    class="panel flex-panel"
                    :style="customStyle"
                    ref="panel"
                    v-show="value"
                >
                    <div class="title">
                        <div class="back" v-show="showBack" @click="onBackClick">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="9"
                                height="14"
                                viewBox="0 0 9 14"
                                fill="none"
                            >
                                <!-- eslint-disable-next-line max-len -->
                                <path class="close-path" d="M7.49993 0.475586L8.91415 1.8898L3.80227 7.00036L8.91415 12.112L7.49993 13.5262L0.974609 7.00091L7.49993 0.475586Z" fill="#222222" />
                            </svg>
                        </div>
                        {{ title }}
                        <svg
                            class="close"
                            @click="onCloseClick"
                            width="40"
                            height="40"
                            viewBox="0 0 40 40"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                class="close-path"
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M23.8499 25.125L14.8344 16.109L16.2486 14.6948L25.2641 23.7108L23.8499 25.125Z"
                            />
                            <path
                                class="close-path"
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M16.2487 25.1249L25.2647 16.1089L23.8505 14.6947L14.8345 23.7107L16.2487 25.1249Z"
                            />
                        </svg>
                    </div>
                    <div ref="content" class="content" @touchmove.stop>
                        <slot></slot>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>
<script>
import formEventBus, { FORM_EVENTS_TYPE } from '../../../utils/event-bus';
import { setPageTitle } from '../../../utils/bridge/ui';
export default {
    name: 'picker-panel',
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        showBack: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: '',
        },
        customClass: {
            type: String,
            default: '',
        },
        customStyle: {
            type: Object,
            default: () => {},
        },
        // 业务方传入当前 native 标题，用于关闭面板后恢复安卓 WebView 因 history.go(-1) 引起的标题变化
        nativeTitle: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            isAppended: false,
            backed: false,
            isMeizu: this.isMeizuBrowser(),
            cachedTitle: '',
        };
    },
    inject: {
        formRoot: { default: null },
    },
    watch: {
        value() {
            if (!this.isAppended) {
                document.body.appendChild(this.$refs.main);
                this.isAppended = true;
            }
            if (this.value) {
                this.toggleVideoShow(false);
                if (this.isMeizu) {
                    return;
                }
                // 优先使用业务方传入的 nativeTitle，其次从 formRoot 上下文取，fallback 到 document.title
                // 关闭面板后用于覆盖安卓 WebView 因 history.go(-1) 自动同步导致的标题变化
                const formRootTitle = (this.formRoot && this.formRoot.nativeTitle) || '';
                this.cachedTitle = this.nativeTitle || formRootTitle || document.title || '';
                console.log('[picker-panel] OPEN', {
                    nativeTitle: this.nativeTitle,
                    formRootTitle,
                    documentTitle: document.title,
                    cachedTitle: this.cachedTitle,
                    href: location.href,
                    historyLen: history.length,
                });
                history.pushState('_PICKER_PAGE', '', location.href);
                window.addEventListener('popstate', this.handlePopstate);
                formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, '', 'PICKER_PAGE_OPEN', {
                    pushUrl: location.href,
                    backed: this.backed,
                    historyLen: history.length,
                    nativeTitle: this.nativeTitle,
                    documentTitle: document.title,
                    cachedTitle: this.cachedTitle,
                });
            } else {
                this.toggleVideoShow(true);
                if (this.isMeizu) {
                    return;
                }
                console.log('[picker-panel] CLOSE', {
                    backed: this.backed,
                    nativeTitle: this.nativeTitle,
                    documentTitle: document.title,
                    cachedTitle: this.cachedTitle,
                    href: location.href,
                    historyLen: history.length,
                });
                formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, '', 'PICKER_PAGE_CLOSE', {
                    pushUrl: location.href,
                    backed: this.backed,
                    historyLen: history.length,
                    nativeTitle: this.nativeTitle,
                    documentTitle: document.title,
                    cachedTitle: this.cachedTitle,
                });
                // V5 防线 1：go(-1) 前预置标题，让 WebView 读到的目标 entry 标题为期望值，减少闪烁
                if (this.cachedTitle) {
                    try {
                        document.title = this.cachedTitle;
                    } catch (e) {
                        // do nothing
                    }
                    setPageTitle({ title: this.cachedTitle }).catch(() => {});
                    console.log('[picker-panel] preClose', {
                        cachedTitle: this.cachedTitle,
                        documentTitle: document.title,
                    });
                    formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, '', 'PICKER_TITLE_RESTORE', {
                        stage: 'preClose',
                        title: this.cachedTitle,
                    });
                }
                // V5 防线 2 & 3：一次性 popstate 同步恢复 + rAF 抢帧
                if (!this.backed && this.cachedTitle) {
                    const title = this.cachedTitle;
                    const onceRestore = () => {
                        window.removeEventListener('popstate', onceRestore);
                        try {
                            document.title = title;
                        } catch (e) {
                            // do nothing
                        }
                        setPageTitle({ title }).catch(() => {});
                        console.log('[picker-panel] popstateSync', {
                            title,
                            documentTitle: document.title,
                        });
                        formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, '', 'PICKER_TITLE_RESTORE', {
                            stage: 'popstateSync',
                            title,
                        });
                        if (typeof requestAnimationFrame === 'function') {
                            requestAnimationFrame(() => {
                                setPageTitle({ title }).catch(() => {});
                                console.log('[picker-panel] rafSync', {
                                    title,
                                    documentTitle: document.title,
                                });
                                formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, '', 'PICKER_TITLE_RESTORE', {
                                    stage: 'rafSync',
                                    title,
                                });
                            });
                        }
                    };
                    window.addEventListener('popstate', onceRestore);
                    window.history.go(-1);
                } else if (!this.backed) {
                    window.history.go(-1);
                }
                window.removeEventListener('popstate', this.handlePopstate);
                // V5 防线 4：保留 150ms / 400ms 三段式兜底
                this.restoreNativeTitle();
            }
        },
    },
    beforeDestroy() {
        // 按返回键时 要把插入到body的picker节点移除
        if (this.isAppended) {
            document.body.removeChild(this.$refs.main);
            this.isAppended = false;
        }
    },
    methods: {
        // 防止页面有<video>挡住弹窗，需要在弹窗打开时隐藏
        toggleVideoShow(show) {
            const visibility = show ? 'visible' : 'hidden';
            // const display = show ? 'block' : 'none';
            try {
                Array.from(document.getElementsByTagName('video')).forEach(ele => {
                    ele.style.visibility = visibility;
                    // ele.style.display = display;
                });
            } catch {
                // do nothing
            }
        },
        handlePopstate(e) {
            this.backed = true;
            e.preventDefault();
            this.onCloseClick();
        },
        onCloseClick() {
            if (this.$refs.content) {
                this.$refs.content.scrollTop = 0;
            }
            this.$emit('input', false);
        },
        onBackClick() {
            this.$emit('back-click');
        },
        isMeizuBrowser() {
            const ua = navigator.userAgent;
            return /MeizuBrowser|MEIZU/.test(ua);
        },
        // 三段式补偿恢复 native 标题：
        // 立即 + 150ms + 400ms 各调用一次 setPageTitle，覆盖安卓 WebView 在 popstate 后异步同步标题的动作
        restoreNativeTitle() {
            if (!this.cachedTitle) {
                console.log('[picker-panel] restoreNativeTitle skip: empty cachedTitle (please pass native-title prop or ensure document.title is set)');
                formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, '', 'PICKER_TITLE_RESTORE', {
                    stage: 'skip',
                    reason: 'empty cachedTitle',
                });
                return;
            }
            const title = this.cachedTitle;
            const titleBeforeDocSet = document.title;
            // 同步写 document.title，兜底 WebView 从 document.title 读取的场景
            try {
                document.title = title;
            } catch (e) {
                console.log('[picker-panel] set document.title error', e && e.message);
            }
            const doSet = (stage) => {
                const titleBefore = document.title;
                setPageTitle({ title }).then(() => {
                    console.log('[picker-panel] restore', stage, {
                        title,
                        titleBefore,
                        titleAfter: document.title,
                        bridgeOk: true,
                    });
                    formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, '', 'PICKER_TITLE_RESTORE', {
                        stage,
                        title,
                        titleBefore,
                        titleAfter: document.title,
                        bridgeOk: true,
                    });
                }).catch(err => {
                    console.log('[picker-panel] restore', stage, {
                        title,
                        titleBefore,
                        titleAfter: document.title,
                        bridgeOk: false,
                        error: err && err.message,
                    });
                    formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, '', 'PICKER_TITLE_RESTORE', {
                        stage,
                        title,
                        titleBefore,
                        titleAfter: document.title,
                        bridgeOk: false,
                        error: err && err.message,
                    });
                });
            };
            console.log('[picker-panel] restoreNativeTitle begin', {
                cachedTitle: title,
                documentTitleBefore: titleBeforeDocSet,
                documentTitleAfter: document.title,
            });
            doSet('immediate');
            setTimeout(() => doSet('150ms'), 150);
            setTimeout(() => doSet('400ms'), 400);
        },

    },
};
</script>
<style lang="less" scoped>
.live-work-picker {
    .panel {
        .content {
            display: flex;
        }
    }

}
.picker-panel {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    overflow: hidden;
    .mask {
        position: absolute;
        width: 100%;
        height: 100%;
        background: #000;
        opacity: 0.3;
    }
    .panel {
        display: flex;
        position: absolute;
        flex-direction: column;
        bottom: 0;
        width: 100%;
        height: 70%;
        background: var(--bg-common, #f8f8f8);
        border-radius: 12px 12px 0 0;
    }
    .flex-panel {
        height: initial;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        // max-height: 85%; /* 最大高度为页面的80% */
        // min-height: 85%;
        max-height: 85%; /* 最大高度为页面的80% */
        min-height: 328px;
    }
    .title {
        font-size: 18px;
        height: 56px;
        line-height: 56px;
        box-sizing: border-box;
        position: relative;
        text-align: center;
        font-weight: 500;
        .back {
            position: absolute;
            top: 8px;
            left: 12px;
            width: 40px;
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            .close-path {
                fill: #222;
            }
        }
        .close {
            position: absolute;
            top: 8px;
            right: 12px;
            width: 40px;
            height: 40px;

            .close-path {
                fill: #222;
            }
        }
    }
    .content {
        flex: 1;
        overflow: auto;
        width: 100%;
        padding-bottom: env(safe-area-inset-bottom);
    }

    .flex-content {
        position: relative;
        // top: 0;
        flex: 1;
        overflow-y: auto;
    }

    // fade
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.3s;
    }
    .fade-enter,
    .fade-leave-to,
    .fade-leave-active {
        opacity: 0;
    }

    .slide-enter-active,
    .slide-leave-active {
        transition: transform 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
    }
    .slide-enter,
    .slide-leave-to {
        transform: translate3D(0, 100%, 0);
    }
}
</style>
